import React from 'react';
import Loader from '../Loader';

export default Spinner = (props) => {
    return (
        <div className={'spinner ' +
            (props.size ? ` ${props.size}` : '') +
            (props.color ? ` color-${props.color}` : '')
        }>

            {/* <Loader showText={false} /> */}

            <div className="loader-ring">
                <div></div>
            </div>

            {props.message &&
                <div className="message">{props.message}</div>
            }

        </div>
    );

};